<template>
  <vx-card class="mb-10" :noShadow="true" v-if="showAdAudienceSuggestions">
    <h4 class="demographics-annotation-title">
      {{ $t('create_campaign.audience_suggestions.title') }}
    </h4>
    <h6 class="mt-3 demographics-annotation-desc">
      {{ $t('create_campaign.audience_suggestions.description') }}
    </h6>

    <!-- Genders Group -->
    <div class="vx-row" v-if="showAdAudienceSuggestionsGenders">
      <div class="vx-col md:w-2/3 w-full text-md font-bold gender-age-mobile-view gender-age-web-view">
        {{ $t('create_campaign.audience_suggestions.genders_title') }}
      </div>

      <div class="vx-col w-full">
        <ul class="gender-mobile-version list-none">
          <li
            id="create-campaign-s5-gender-options-buttons"
            class="gender inline-block check-item-box"
            v-for="(gender, index) in genders"
            :key="'genders-' + index"
            :class="{'active': isGenderActive(gender)}"
            @click="toggleGender(gender.id)"
          >
            {{ gender.name }}
          </li>
        </ul>
      </div>

    </div>

    <!-- Ages Group -->
    <div class="vx-row" v-if="showAdAudienceSuggestionsAges">
      <div class="vx-col md:w-1/3 w-full text-md font-bold age-title gender-age-mobile-view gender-age-web-view">
        {{ $t('create_campaign.audience_suggestions.ages_title') }}
      </div>

      <div class="vx-col w-full">
        <ul class="age-mobile-version list-none">
          <li
            id="create-campaign-s5-age-options-buttons"
            class="age inline-block check-item-box"
            v-for="(ageGroup, index) in ageGroups"
            :key="'ageGroups-' + index"
            :class="{'active': isAgeRangeActive(ageGroup)}"
            @click="toggleAgeGroup(ageGroup.id)"
          >
            {{ ageGroup.name }}
          </li>
        </ul>
      </div>
    </div>
  </vx-card>
</template>

<script>
import {get, isEmpty} from 'lodash'

export default {
  props: {
    value: {
      required: true,
      type: Object
    },
    adsetIndex: {
      required: true,
      type: Number
    },
    adIndex: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      audienceSuggestions: get(window.initialCampaignData, `adsets[${ this.adsetIndex }].ads[${ this.adIndex }].audience_suggestion.suggestions`, { genders: [], age_groups: [] })
    }
  },
  created () {
    this.handleAdAudienceSuggestionsObject()
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  computed: {
    genders () {
      return this.$store.getters['campaign/targetingLookups'].genders
    },

    ageGroups () {
      return this.$store.getters['campaign/targetingLookups'].age_groups
    },

    showAdAudienceSuggestions () {
      if (this.value.show_audience_suggestions === true) {
        return true
      }

      const adAges = get(this.audienceSuggestions, 'age_groups', []),
        adGenders = get(this.audienceSuggestions, 'genders', [])
      if (adAges.length === 0 || adGenders.length === 0) {
        return true
      }

      return false
    },
    showAdAudienceSuggestionsAges () {
      if (this.value.show_audience_suggestions === true || isEmpty(get(this.audienceSuggestions, 'age_groups', []))) {
        return true
      }

      return false
    },
    showAdAudienceSuggestionsGenders () {
      if (this.value.show_audience_suggestions === true || isEmpty(get(this.audienceSuggestions, 'genders', []))) {
        return true
      }

      return false
    }
  },
  methods: {
    toggleGender (id) {
      const index = this.value.audience_suggestions.genders.findIndex(i => i === id)

      if (index > -1) {
        this.value.audience_suggestions.genders.splice(index, 1)
      } else {
        this.value.audience_suggestions.genders.push(id)
      }

    },
    toggleAgeGroup (id) {
      const index = this.value.audience_suggestions.age_groups.findIndex(i => i === id)

      if (index > -1) {
        this.value.audience_suggestions.age_groups.splice(index, 1)
      } else {
        this.value.audience_suggestions.age_groups.push(id)
      }
    },
    handleAdAudienceSuggestionsObject () {
      const genders = get(this.value, 'audience_suggestions.genders', []),
        age_groups = get(this.value, 'audience_suggestions.age_groups', [])
      this.value.audience_suggestions = {
        genders,
        age_groups
      }
    },
    isGenderActive (gender) {
      if (get(this.value, 'audience_suggestions.genders', []).includes(gender.id)) {
        return true
      }

      return false
    },
    isAgeRangeActive (ageGroup) {
      if (get(this.value, 'audience_suggestions.age_groups', []).includes(ageGroup.id)) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss">
  .demographics-annotation-title {
    font-weight: 500;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.75);
  }

  .gender-age-web-view {
    color:#2C2C2C;
  }

  .age-title {
    margin-top: 24px;
  }

  .demographics-annotation-desc {
    color: #999;
    font-size: 14px;
    margin-bottom: 32px;
    line-height: 24px;
    font-weight: normal;
  }

  .list-none {
    margin-top: 16px !important;
  }

  .check-item-box {
    min-width: 96px;
    padding: 12px 0px;
    border-radius: 2rem;
    color: #0092d7;
    border: 1px solid #0092d7;
    background-color: #FFFFFF;
    font-family: Poppins;
    font-style: normal;
    font-size: 1rem;
    line-height: 1rem;
    cursor: pointer;
    text-align: center;
  }

  .check-item-box.active {
    background: #0092D7;
    border-radius: 50px;
    color: #FFFFFF;
  }

  .age,
  .gender {
    margin-right: 16px;
  }


  @media (max-width: 576px) {
    .gender-age-mobile-view {
      font-size: 12px;
      // margin-bottom: 20px;
    }

    .gender-mobile-version,
    .age-mobile-version {
      width: 100%;
      text-align: left;
      li {
        width: 47%;
        text-align: center;
      }

      li:first-child {
        margin-left: 0px;
        margin-right: 12px !important;
      }

      li:nth-child(3) {
        margin-left: 0px;
        margin-right: 12px !important;
      }
    }

    .age,
    .gender {
      margin-right: 0px;
    }

    .age-mobile-version {
      li:not(:first-child):not(:nth-child(2)) {
        margin-top: 24px;
      }
    }
  }
</style>
